'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  dropdown: {
    position: 'relative',
    maxWidth: '100%',
    outline: 0
  },
  list: {
    position: 'absolute',
    boxShadow: '0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)',
    minWidth: '100%',
    zIndex: 1000
  },
  justifyRight: {
    right: 0
  },
  valignTop: {
    bottom: 30
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@billes/components/lib/components/Dropdown/styles.js
// module id = 406
// module chunks = 5